import React, { useState, useEffect } from "react";
import axios from "axios";
import SpecialTable from "../../Utills/Table/SpecialTable";
import Special from "../../components/Modal/Special/AddSpecialModal";
import Switch from "@mui/material/Switch";

const SpecialPage = ({ check, change }) => {
  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://tsetsegtuw.templateapi.xyz/event"
        ); // Ensure this endpoint is correct
        setEvent(response.data.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
    if (loading) {
      axios
        .get("https://tsetsegtuw.templateapi.xyz/event")
        .then((e) => setEvent(e.data.data))
        .catch((e) => console.log(e))
        .finally(() => setLoading(false));
    }
  }, [loading]);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-start min-h-screen ml-[18vw] w-[80vw] p-6">
      <div className="w-full flex justify-end mb-4 items-center">
        <Special />
        <Switch
          checked={check}
          onChange={change}
          inputProps={{ "aria-label": "controlled" }}
        />
      </div>
      <div className="w-full max-w-7xl">
        <SpecialTable specials={Special} />
      </div>
    </div>
  );
};

export default SpecialPage;
